<ng-container *ngIf="communicator.checkUser$ | async as user">
  <ng-container *ngIf="user[keyUser] === '1'">
    <button [class]="'btn p-0 ' + classButton" (click)="addRemoveFavorite($event)">
      <i *ngIf="isRed" class="fa fa-heart"></i>
      <i *ngIf="!isRed" class="far fa-heart"></i>
    </button>
  </ng-container>

</ng-container>
